import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import FeedbackModalWrapper from './components/FeedbackModalWrapper';
import { setPhone } from '../user/ducks';
import { Gap, Phone, FormLabel as Label } from '~ui-kit';
import { primaryColor } from '~theme';
import { isPhoneNumberValid } from '../../forms/validations';

const ChangePhoneNumberModal = props => {
  const phone = useSelector(state => state.user.data.phone);
  // phone isn't defined in time for useState I guess, so use the effect
  const [localNumber, setLocalNumber] = useState('');

  const dispatch = useDispatch();

  const show = useSelector(state => state.modals.show);
  const error = isPhoneNumberValid(localNumber);

  useEffect(() => {
    // Reset state when hidden
    if (!show) {
      setLocalNumber(phone);
    }
  }, [show]);

  // For autofilling
  useEffect(() => {
    setLocalNumber(phone);
  }, [phone]);

  const handleSubmit = () => {
    dispatch(setPhone(localNumber));
  };

  return (
    <FeedbackModalWrapper
      name="CHANGE_PHONE_NUMBER"
      title="Puhelinnumeron lisääminen"
      confirmOnClick={handleSubmit}
      confirmDisabled={error}
    >
      <Wrapper>
        <p>
          Voit lisätä henkilökohtaisen puhelinnumeron yhteystietoihisi. Ethän
          syötä yhteiskäyttöisiä puhelinnumeroita tähän kenttään.
        </p>
        <Gap height="24px" />
        <Label>Puhelinnumero</Label>
        <Phone
          value={localNumber}
          onChange={event => setLocalNumber(event.target.value)}
        />
        <Gap height="24px" />
      </Wrapper>
    </FeedbackModalWrapper>
  );
};

const Wrapper = styled.div`
  color: ${primaryColor};
`;

export default ChangePhoneNumberModal;
